import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const ruleSet = api(async function ruleSet({ id }) {
    return query(
        gql`
            query GetRuleSet($id: String!) {
                ruleSet(id: $id) {
                    id
                    name
                    description
                    type
                    defaultAction
                    rules {
                        id
                        type
                        name
                        justification
                        combinator
                        enabled
                        ruleSetId
                        ruleSetName
                        conditions {
                            field
                            operator
                            value
                        }
                        action {
                            type
                            multiplier
                            costKind
                            fixedAmount
                            timeKind
                            timeValue
                            frequencyMultiplier
                        }
                    }
                    isArchived
                    created
                    modified
                    parentRuleSetId
                    parentRuleSetName
                }
            }
        `,
        { id },
        { returns: "ruleSet" }
    )
})
